import { Controller } from "@hotwired/stimulus";
import "pannellum";

type PannellumViewer = ReturnType<typeof pannellum.viewer>;

export default class extends Controller<HTMLElement> {
  static readonly values = {
    src: String,
  };

  static readonly targets = ["pannellumContainer"];

  declare readonly hasSrcValue: boolean;
  declare readonly srcValue: string;

  declare readonly hasPannellumContainerTarget: boolean;
  declare readonly pannellumContainerTarget: HTMLElement;

  private _panoramaViewer: PannellumViewer | null = null;

  connect() {
    this._initial = this._initial.bind(this);
    this._destroy = this._destroy.bind(this);

    this.element.addEventListener("shown.bs.modal", this._initial);
    this.element.addEventListener("hide.bs.modal", this._destroy);
  }

  disconnect() {
    this._destroy();
    this.element.removeEventListener('shown.bs.modal', this._initial);
    this.element.removeEventListener('hide.bs.modal', this._destroy);
  }

  private _initial() {
    if (
      !this._panoramaViewer &&
      this.hasPannellumContainerTarget &&
      this.hasSrcValue
    ) {
      this._panoramaViewer = pannellum.viewer(this.pannellumContainerTarget, {
        type: "equirectangular",
        panorama: this.srcValue,
        autoLoad: true,
        showControls: true,
      });
    }
  }

  private _destroy() {
    if (this._panoramaViewer) {
      this._panoramaViewer.destroy();
      this._panoramaViewer = null;
    }
  }
}
